import { useCompanyContext } from '../../../../contexts/company';
import { PaddedSection } from '../../../Account/components/Section';
import BankDetailsSection from './SubSections/BankDetails';
import BrokerageDetailsSection from './SubSections/BrokerageDetails';
import PrincipalCompanyDetailsSection from './SubSections/PrincipalCompanyDetails';
import RepresentativeSection from './SubSections/Representative';

export const firmDetailsRefName = 'firm-details';

export default function FirmDetailsSection() {
  const { company: { companyDetails: { authorisationType } } } = useCompanyContext();
  const principalCompanyShown = authorisationType === 'APPOINTED_REPRESENTATIVE';

  return (
    <PaddedSection
      id={firmDetailsRefName}
      refName={firmDetailsRefName}
      title="Firm Details"
      titleIcon={<></>}
    >
      <BrokerageDetailsSection />
      <RepresentativeSection />
      <BankDetailsSection />
      {principalCompanyShown && <PrincipalCompanyDetailsSection />}
    </PaddedSection>
  );
}
